import { ChangeDetectionStrategy, Component, computed, effect, input, linkedSignal, output, Signal, WritableSignal } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatTooltipModule } from '@angular/material/tooltip';
import { computeNextRun, CronConfiguratorComponent, CronPreview, describeCron } from '@iot-platform/iot-platform-ui';
import { BusinessProfile, FavoriteView, FavoriteViewExport, FavoriteViewReportStatus } from '@iot-platform/models/common';
import { DateFormatPipe } from '@iot-platform/pipes';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'iot-platform-ui-favorite-view-report-form',
  imports: [TranslatePipe, MatSlideToggleModule, MatIconModule, MatTooltipModule, DateFormatPipe, CronConfiguratorComponent],
  templateUrl: './report-form.component.html',
  styleUrls: ['./report-form.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class FavoriteViewReportFormComponent {
  favoriteView = input<FavoriteView>();
  businessProfile = input<BusinessProfile>();
  formValue = output<FavoriteViewExport>();
  formStateChanged = output<boolean>();

  status: WritableSignal<FavoriteViewReportStatus> = linkedSignal<FavoriteView | undefined, FavoriteViewReportStatus>({
    source: this.favoriteView,
    computation: (favoriteView) => favoriteView?.export?.status ?? FavoriteViewReportStatus.DISABLED
  });

  cron: WritableSignal<string | null> = linkedSignal<FavoriteView | undefined, string | null>({
    source: this.favoriteView,
    computation: (favoriteView) => favoriteView?.export?.cron ?? null
  });

  timezone: Signal<string> = computed(() => this.businessProfile()?.timezoneDetails?.name ?? this.businessProfile()?.timezone ?? 'UTC');
  preview: Signal<CronPreview> = computed(() => describeCron(this.cron(), this.timezone()));
  nextRun: Signal<string | null> = computed(() => computeNextRun(this.cron(), this.timezone()));
  STATUS = FavoriteViewReportStatus;

  emitEffect = effect(() => {
    const status = this.status();
    const cron = this.cron();
    const currentExport = this.favoriteView()?.export;
    const changed = status !== currentExport?.status || cron !== currentExport?.cron;

    this.formStateChanged.emit(changed);
    this.formValue.emit({
      ...currentExport,
      status,
      cron
    });
  });
}
